import { render, staticRenderFns } from "./ProductDesignFormAcc.vue?vue&type=template&id=673c2212&"
import script from "./ProductDesignFormAcc.vue?vue&type=script&lang=js&"
export * from "./ProductDesignFormAcc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports